import { useParams } from "react-router-dom";
import { FacilityGovernanceTable } from "./_FacilityGovernanceTable";

export default function FacilityPeopleGovernancePage() {
  const { facilityId } = useParams();

  return <FacilityGovernanceTable facilityId={facilityId!} />;
}
